module.exports = __webpack_public_path__ + "static/media/guest2x.04df7906.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/guest2x.png
 ** module id = 2073
 ** module chunks = 44
 **/